export default class Constants {
  static isNewApi = process.env.REACT_APP_USE_NEW_API === "true"

  static get DateFormats() {
    return {
      short: "YYYY/MM/DD HH:mm",
      long: "YYYY/MM/DD (ddd) HH:mm:ss",
      mysql: "YYYY-MM-DD HH:mm:ss",
    }
  }

  static get URLs() {
    const API_VERSION = "v2"
    const CLIENT_HOST =
      process.env.NODE_ENV === "production" ? this.generateApiDomain() : ""
    const OAUTH_HOST =
      process.env.NODE_ENV === "production"
        ? this.generateApiDomain()
        : process.env.REACT_APP_API_DOMAIN

    const createApiHost = (path) =>
      this.isNewApi
        ? `${CLIENT_HOST}/api/${path}`
        : `${CLIENT_HOST}/api/${API_VERSION}/wall`

    const AUTH_API_HOST = createApiHost("auth")
    const TOPIC_MEDIA_API_HOST = createApiHost("topic-media")
    const CATEGORY_API_HOST = createApiHost("category")
    const SETTING_API_HOST = createApiHost("setting")
    const YOUTUBE_API_HOST = createApiHost("youtube")
    const TWITTER_API_HOST = createApiHost("twitter")
    const INSTAGRAM_API_HOST = createApiHost("instagram")
    const FACEBOOK_API_HOST = createApiHost("facebook")

    return {
      LOGIN: `${AUTH_API_HOST}/login`,
      LOGOUT: `${AUTH_API_HOST}/logout`,
      CHECK_LOGGED_IN: `${AUTH_API_HOST}/check-logged-in`,
      GET_ALL_CATEGORIES: `${CATEGORY_API_HOST}/get-all-categories`,
      GET_TOPICS: `${TOPIC_MEDIA_API_HOST}/get-topics`,
      CREATE_TOPIC: `${TOPIC_MEDIA_API_HOST}/create-topic`,
      EDIT_TOPIC: `${TOPIC_MEDIA_API_HOST}/edit-topic`,
      DELETE_TOPIC: `${TOPIC_MEDIA_API_HOST}/delete-topic`,
      FETCH_TOPIC_ORDER: `${TOPIC_MEDIA_API_HOST}/fetch-topic-order`,
      CREATE_CATEGORY: `${CATEGORY_API_HOST}/create-category`,
      EDIT_CATEGORY: `${CATEGORY_API_HOST}/edit-category`,
      DELETE_CATEGORY: `${CATEGORY_API_HOST}/delete-category`,
      GET_KS_SETTINGS: `${SETTING_API_HOST}/get-ks-settings`,
      EDIT_KS_SETTINGS: `${SETTING_API_HOST}/edit-ks-settings`,
      PATROL_TOPIC: `${TOPIC_MEDIA_API_HOST}/patrol-topic`,

      GET_YOUTUBE_CHANNEL: `${YOUTUBE_API_HOST}/get-youtube-channels`,
      ADD_YOUTUBE_CHANNEL: `${YOUTUBE_API_HOST}/add-youtube-channel`,
      ENABLE_YOUTUBE_CHANNEL: `${YOUTUBE_API_HOST}/enable-youtube-channel`,
      DISABLE_YOUTUBE_CHANNEL: `${YOUTUBE_API_HOST}/disable-youtube-channel`,

      OAUTH_FACEBOOK_PAGES: `${OAUTH_HOST}/oauth/facebook/oauth.php`,
      GET_FACEBOOK_PAGES: `${FACEBOOK_API_HOST}/get-facebook-pages`,
      ENABLE_FACEBOOK_PAGES: `${FACEBOOK_API_HOST}/enable-facebook-page`,
      DISABLE_FACEBOOK_PAGES: `${FACEBOOK_API_HOST}/disable-facebook-page`,

      GET_TWITTER_ACCOUNT: `${TWITTER_API_HOST}/get-twitter-accounts`,
      ADD_TWITTER_ACCOUNT: `${TWITTER_API_HOST}/add-twitter-account`,
      ENABLE_TWITTER_ACCOUNT: `${TWITTER_API_HOST}/enable-twitter-account`,
      DISABLE_TWITTER_ACCOUNT: `${TWITTER_API_HOST}/disable-twitter-account`,

      OAUTH_INSTAGRAM_ACCOUNT: `${OAUTH_HOST}/oauth/instagram/oauth.php`,
      GET_INSTAGRAM_ACCOUNT: `${INSTAGRAM_API_HOST}/get-instagram-accounts`,
      ENABLE_INSTAGRAM_ACCOUNT: `${INSTAGRAM_API_HOST}/enable-instagram-account`,
      DISABLE_INSTAGRAM_ACCOUNT: `${INSTAGRAM_API_HOST}/disable-instagram-account`,
    }
  }

  /**
   * API用のドメインを自身のホスト名から生成
   * @returns {string}
   */
  static generateApiDomain = () => {
    function changeApi(match, p1, p2, p3, offset, string) {
      return `${p1}-api${p3}`
    }
    const hostname = window.location.hostname
    const regex = /^(.*?)(-admin|-wall)(.*?\..*?)$/
    if (hostname === "localhost") {
      return ""
    } else {
      return `https://${hostname.replace(regex, changeApi)}`
    }
  }
}
